<template>
  <v-hover v-slot:default="{hover}">
    <v-card :class="{ 'on-hover': hover}">
      <v-img
        :src="$assets.url(model.file.thumbnailUrl)"
        height="250"
        lazy-src="../../assets/lazy-src.jpg"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="red"></v-progress-circular>
          </v-row>
        </template>
        <v-container fluid class="fill-height">
          <v-row no-gutters align="start" class="fill-height">
            <v-col cols="6">
              <v-chip
                color="orange darken-1"
                text-color="white"
                small
                v-if="model.status=='rework'"
              >En retravail</v-chip>
            </v-col>
            <v-col cols="6" class="text-right" style="position:relative;z-index:9">
              <v-btn
                x-small
                fab
                dark
                color="primary"
                v-if="model.status!='rework'"
                @click="reworkDialog=true"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                x-small
                fab
                dark
                color="primary"
                :href="$assets.url(model.file.url)"
                target="_blank"
                v-if="model.status!='rework'"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-expand-transition>
          <div
            class="d-flex flex-column transition-fast-in-fast-out v-card--reveal white--text"
            style="height: 100%;"
            v-if="hover"
            @click="zoom=true"
          >
            <v-icon x-large color="white">mdi-magnify-plus-outline</v-icon>
          </div>
        </v-expand-transition>
      </v-img>
      <v-dialog v-model="zoom" max.width="80%">
        <v-card>
          <v-img
            :src="$assets.url(model.file.url)"
            contain="true"
            max-height="800"
            lazy-src="../../assets/lazy-src.jpg"
          ></v-img>
        </v-card>
      </v-dialog>
      <v-dialog v-model="reworkDialog" max-width="800px">
        <v-card>
          <v-card-title>Demander des modifications</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <p>Vous pouvez demander des retouches sur l'image</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <label>Image de références pour vos modifications (optionel)</label>
                <file-upload v-model="rework.reference"></file-upload>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <label>Commentaires</label>
                <v-textarea v-model="rework.comment"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn small @click="reworkDialog=false" class="themed">Annuler</v-btn>
            <v-spacer />
            <v-btn smal class="themed" @click="submit()">Soumettre</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-hover>
</template>

<script>
import FileUpload from "../FileUpload";
import { mapActions } from "vuex";
export default {
  components: {
    FileUpload
  },
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    zoom: false,
    reworkDialog: false,
    rework: {
      reference: null,
      comment: null
    },
    model: null
  }),
  mounted() {
    this.model = this.file;
  },
  methods: {
    ...mapActions("order", ["sendRework"]),
    submit() {
      this.sendRework({ fileId: this.file.id, rework: this.rework }).then(
        file => {
          console.log("REWORK", file);
          this.model = file;
          this.reworkDialog = false;
          this.rework.reference = null;
          this.rework.commnet = null;
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
.v-card--reveal {
  background-color: rgba(10, 37, 44, 0.4);
}
</style>